module.exports = __webpack_public_path__ + "img/kkb_steelplate.82747c60.jpg";